import React from 'react';
import { useFetchSoftwareVersion } from '../Hooks/common/useFetchSoftwareVersion';

function VersionBanner() {
    const version = useFetchSoftwareVersion();

    return (
        <div className="flex justify-end items-end">
            {version?.isLoading ? (
                <span className="w-4 h-4 border-2 border-t-transparent border-custom-green animate-spin mr-1" aria-hidden="true" />
            ) : version?.isError ? (
                <span className="text-red-500 font-bold">Failed to load version</span>
            ) : version?.isSuccess ? (
                <div className="text-custom-green font-extrabold text-right">
                    Version: {version?.data?.Version}
                </div>
            ) : null}
        </div>
    );
}
export default VersionBanner;
